export default function RightFitSection() {
  return (
    <section id="right-fit" className="py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block bg-secondary-100 text-secondary-800 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-5">
            Placement Guidance
          </span>
          <h2 className="heading-font text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 max-w-3xl mx-auto leading-tight">
            Is MCT the <span className="italic text-primary-600">Right Fit?</span>
          </h2>
          <p className="text-foreground-600 mt-5 max-w-2xl mx-auto leading-relaxed text-base md:text-lg">
            We want every placement to succeed. Here&apos;s a guide to help determine if our program matches the youth you&apos;re considering.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-accent-200/70">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-12 flex items-center justify-center bg-accent-100 text-accent-700 rounded-xl">
                <i className="ri-check-line text-xl"></i>
              </span>
              <h3 className="heading-font text-2xl md:text-3xl font-bold text-foreground-900">A Great Fit</h3>
            </div>
            <p className="text-foreground-600 text-sm mb-6 label-font">MCT may be a great fit for youth who:</p>
            <ul className="space-y-4">
              {[
                'Benefit from a stable, relationship-based environment',
                'Are working toward independence',
                'Need support with education, employment, or life skills',
                'Thrive in a structured home with individualized programming',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center text-accent-600 flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-line"></i>
                  </span>
                  <span className="text-foreground-700 text-sm leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-12 flex items-center justify-center bg-secondary-100 text-secondary-700 rounded-xl">
                <i className="ri-information-line text-xl"></i>
              </span>
              <h3 className="heading-font text-2xl md:text-3xl font-bold text-foreground-900">May Not Be the Best Fit</h3>
            </div>
            <p className="text-foreground-600 text-sm mb-6 label-font">MCT may not be the best fit for youth who currently require:</p>
            <ul className="space-y-4">
              {[
                'Secure treatment',
                'Hospital-level psychiatric care',
                'Intensive medical supports beyond our scope',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center text-foreground-400 flex-shrink-0 mt-0.5">
                    <i className="ri-close-circle-line"></i>
                  </span>
                  <span className="text-foreground-600 text-sm leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-6 bg-background-50 rounded-xl p-4 border border-background-200/70">
              <p className="text-foreground-500 text-xs leading-relaxed">
                Not sure if a youth is the right fit? We&apos;re happy to discuss. Reach out and we can talk through the placement together.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}